import * as injectorHelper from './app-injector';
import { LocalizeService } from '../../app/insa-services/localize.service';


import { appConfig } from '../../insaweb.config'

export module MultiSelectCustomModule {
    let MultiSelectIsOpening: boolean;
    let Globals = { MultiSelectIsOpening };

    export function KendoPartnerDropdown(selector, partnerData, partnerPortfolio, indexOfPartner) {
        const _localize = injectorHelper.AppInjector.get(LocalizeService);    
        
        if (partnerData !== undefined && partnerData.length > 0) {
            let partnerDropdownOptions: kendo.ui.DropDownListOptions = {};
            partnerDropdownOptions.change = filterMultiSelect;
            partnerDropdownOptions.dataSource = partnerData;
            partnerDropdownOptions.dataTextField = partnerPortfolio;
            partnerDropdownOptions.dataValueField = indexOfPartner;
            partnerDropdownOptions.filter = "contains";

            $(selector).kendoDropDownList(partnerDropdownOptions);
            partnerDropdownSize();
        }
    }

    export function KendoPortfolioMultiSelect(selector, portfolioData, portfNumber, portfIndex, closeDate) {
        const _localize = injectorHelper.AppInjector.get(LocalizeService);    

        if (portfolioData !== undefined && portfolioData.length > 0) {
            let dataSourceOptions: kendo.data.DataSourceOptions = {};
            dataSourceOptions.data = portfolioData;
            dataSourceOptions.schema = { model: { fields: { CloseDate: { type: "date" } } } };

            let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);

            let portfMultiSelectOptions: kendo.ui.MultiSelectOptions = {};
            portfMultiSelectOptions.dataSource = dataSource;
            portfMultiSelectOptions.dataTextField = portfNumber;
            portfMultiSelectOptions.dataValueField = portfIndex;
            portfMultiSelectOptions.placeholder =_localize.getLocalizedResource('Res1353').toUpperCase(); //_localize.getTranslation("SELECT PORTFOLIO");
            portfMultiSelectOptions.filter = "contains";
            portfMultiSelectOptions.headerTemplate = kendo.template('<div class="k-list-scroller">' +
            '<ul class="k-list k-reset">' +    
            '<li class="k-item"><input type="checkbox" id="checkAll" checked> ' + _localize.getTranslation('ALL') +
            '</li></ul></div>'
            );
            portfMultiSelectOptions.itemTemplate = kendo.template('<input type="checkbox" class="multiSelectPortfolios" checked/> ' +
            '#:data.Number# #: (data.CloseDate!==null) ? kendo.toString(data.CloseDate, "(dd.MM.yyyy)") : "" # '
               );
               portfMultiSelectOptions.tagTemplate = kendo.template('# if (values.length < 2) { #' +
               '# for (var idx = 0; idx < values.length; idx++) { #' +
               '<span class="msTagCustomTempl"> #:data.dataItems[idx].Number# </span>' +
               '# } #' +
               '# } else { #' +
               ' <span class="msTagCustomTempl"> #:values.length#' + _localize.getTranslation(' out of ') + '#:values.length#</span>' +
               '# } # ');

            //    holi
            // portfMultiSelectOptions.tagTemplate = kendo.template('# if (values.length < 2) { #' +
            //     '# for (var idx = 0; idx < values.length; idx++) { #' +
            //     '<span class="msTagCustomTempl"> #:data.dataItems[idx].Number# </span>' +
            //     '# } #' +
            //     '# } else { #' +
            //     ' <span class="msTagCustomTempl"> #:values.length#' + _localize.getTranslation(' out of ') + '#:values.length#</span>' +
            //     '# } # ');
            portfMultiSelectOptions.tagMode = "single";
            portfMultiSelectOptions.autoClose = false;
            portfMultiSelectOptions.open = onMultiselectPortfoliosOpen;
            portfMultiSelectOptions.close = onMultiselectPortfoliosClose;
            portfMultiSelectOptions.select = onMultiselectPortfolioSelect;
            portfMultiSelectOptions.change = onMultiselectPortfoliosChange;
            portfMultiSelectOptions.value = getMultiselectValues(portfolioData);
            portfMultiSelectOptions.dataBound = onMultiselectDataBound;
            $(selector).kendoMultiSelect(portfMultiSelectOptions)
            onMultiselectPortfoliosChange(undefined);
            
            $(".k-widget.k-multiselect.k-header").click(function () {
                if (!Globals.MultiSelectIsOpening) {
                    $(selector).data("kendoMultiSelect").toggle();
                }
            });
            multiselectSize();
            $("#checkAll").click(toggleCheckAllState);
            $("#showClosedCheckbox").click(filterMultiSelect);
            filterMultiSelect(undefined);
        }
    }
    function onMultiselectDataBound(e) {
        updateMultiSelectCheckAllElementState();
    }

    function onMultiselectPortfolioSelect(e) {
        let input = e.item.children("input");
        input.prop("checked", !e.item.hasClass("k-state-selected"));
    }

    function multiselectSize(){
        let  multiSelect: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        if (multiSelect !== undefined && appConfig.multiSelectWidthSettings) {
            if (window.innerWidth > 1200) {
                multiSelect.list.width("30vw");
           } else {
                multiSelect.list.width('calc(100vw - 50px)');
           }
            multiSelect.resize();
        }
    }

   function partnerDropdownSize(){
    let dropdownList: kendo.ui.DropDownList = $("#partner").data("kendoDropDownList");
    if (dropdownList !== undefined && appConfig.dropdownWidthSettings) {
        if (window.innerWidth > 1200) {
            dropdownList.list.width("30vw");
       } else {
        dropdownList.list.width('calc(100vw - 30px)');
       }
       dropdownList.resize();
    }
   }

    export function onMultiselectPortfoliosChange(e) {
        let evt = e || window.event;
        let currData: kendo.ui.DropDownList = $("#currency").data("kendoDropDownList");
        let multiSelect: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        if (multiSelect !== undefined) {
            let multiSelectDataItem = multiSelect.dataItems();
            let refCurrency: any;

            if (multiSelectDataItem.length > 0) {
                refCurrency = multiSelectDataItem[0].RefCurrency;
            } else {
                refCurrency = 0;
            }
            currData.value(refCurrency);
            updateMultiSelectCheckAllElementState();
            stopPropagation(evt);
        }
    }
  
    function stopPropagation(event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        else if (window.event) {
            window.event.stopPropagation();
        }
    }

    function filterMultiSelect(e) {
        let partnerDropdown: kendo.ui.DropDownList = $("#partner").data("kendoDropDownList");
        let multiSelectBox: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        if (partnerDropdown !== undefined && multiSelectBox !== undefined) {
            let searchstring = multiSelectBox.input[0]['value'];
            let partnerIndex = partnerDropdown.dataItem().PartnerIndex;
            let currentdata = multiSelectBox.dataItems();
            if (e !== undefined && e.sender === partnerDropdown) {
                $("#portfoliosMultiSelect").data("kendoMultiSelect").dataSource.filter([]);
                $("#portfoliosMultiSelect").data("kendoMultiSelect").input[0]['value'] = "";
                currentdata = multiSelectBox.dataSource.view();
            }
            let filters = buildMultiselectFilters(partnerIndex);
            multiSelectBox.dataSource.filter(filters);
            multiSelectBox.setDataSource(multiSelectBox.dataSource);
            multiSelectBox.value(getMultiselectValues(currentdata));
            multiSelectBox.trigger("change");
        }
    }


   

    function buildMultiselectFilters(partnerIndex) {
        let multiSelectBox: any;
        multiSelectBox = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        let filters = [];
        if (partnerIndex !== 0) {
            filters.push({ field: "PartnerIndex", operator: "eq", value: partnerIndex });
        }
        if (!$("#showClosedCheckbox").is(":checked")) {
            filters.push({ field: "CloseDate", operator: "eq", value: null });
        }
        if (multiSelectBox.dataSource._filter !== undefined) {
            multiSelectBox.dataSource._filter.filters.forEach(e => {
                if (e.field === "Number") {
                    filters.push(e);
                }
            });
        }
        return filters;
    }

    function toggleCheckAllState() {
        let multiSelect:kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        if ($("#checkAll").is(":checked")) {
            filterMultiSelect(undefined);
            multiSelect.value(getMultiselectValues(multiSelect.dataSource.view()));
            $('.multiSelectPortfolios').prop("checked", true);
        } else {
            multiSelect.value([]);
            $('.multiSelectPortfolios').prop("checked", false);
        }
        multiSelect.trigger("change");
    }

    function updateMultiSelectCheckAllElementState() {
        let multiSelect: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        let items = multiSelect.ul.find("li");

        items.each(function () {
            let element = $(this);
            let input = element.children("input");
            input.prop("checked", element.hasClass("k-state-selected"));
            if (!input.prop("checked")) {
                $("#checkAll").prop('checked', false);
            }
        });
        if ($('.multiSelectPortfolios:checked').length === $('.multiSelectPortfolios').length) {
            $('#checkAll').prop('checked', true);
        } else {
            $('#checkAll').prop('checked', false);
        }
    }

    function getMultiselectValues(data) {
        let values = new Array();
        if (data[0] != null) {
            for (let i = 0; i < data.length; i++) {
                if (data[i] == null)
                    break;
                values[i] = data[i].Index;
            }
        }
        return values;
    }

    function onMultiselectPortfoliosOpen() {
        updateMultiSelectCheckAllElementState();
        Globals.MultiSelectIsOpening = true;
        setTimeout(function () {
            Globals.MultiSelectIsOpening = false;
        }, 200);

        $("#portfoliosMultiSelect_taglist").hide();
        setMultiSelectPlaceholder();
    }

    function onMultiselectPortfoliosClose(e) {
        $("#portfoliosMultiSelect_taglist").show();
        removeMultiSelectPlaceholder();
    }

    function setMultiSelectPlaceholder() {
        let multiSelect:kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        multiSelect.input[0]['value'] = "";
        $(".k-multiselect-wrap.k-floatwrap").find('.k-input').css("visibility", "visible"); 
        $(".k-multiselect-wrap.k-floatwrap").css("padding-left", "10px");
    }

    function removeMultiSelectPlaceholder() {
        const _localize = injectorHelper.AppInjector.get(LocalizeService);    
        
        let multiSelect: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        $(".k-multiselect-wrap.k-floatwrap").css("padding-left", "");
        $(".k-multiselect-wrap.k-floatwrap").find('.k-input').css("visibility", "hidden");
        if (multiSelect.value().length === 0) {
            $(".k-multiselect-wrap.k-floatwrap").find('.k-input').css("visibility", "visible");
            $(".k-multiselect-wrap.k-floatwrap").find('.k-input').css("width", "auto");
            multiSelect.input[0]['value'] = _localize.getLocalizedResource('Res1353').toUpperCase();
        }
       
    }
}








// WEBPACK FOOTER //
// ./app/insa-custom-scripts/multiselect-filter.ts